import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getAuthErrorMessage } from '../../utils/authErrors';
import './Signup.css';

export default function Signup() {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [newsletter, setNewsletter] = useState(true);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    setLoading(true);
    try {
      await register({
        name: fullName.trim() || 'New User',
        email: email.trim(),
        password,
      });
      navigate('/', { replace: true });
    } catch (err) {
      setError(getAuthErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-page">
      <div className="signup-inner">
        <div className="signup-illustration">
          <div className="signup-illustration-circle">
            <img src={`${process.env.PUBLIC_URL || ''}/classroom.png`} alt="" className="signup-illustration-img" />
          </div>
        </div>
        <div className="signup-form-wrap">
          <h1 className="signup-title">Sign up with email</h1>
          <form onSubmit={handleSubmit} className="signup-form">
            {error && <p className="signup-error">{error}</p>}
            <label className="signup-label">
              <input
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                className="signup-input"
                placeholder="Full name"
                autoComplete="name"
              />
            </label>
            <label className="signup-label">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="signup-input"
                placeholder="Email"
                required
                autoComplete="email"
              />
            </label>
            <label className="signup-label">
              <div className="signup-password-wrap">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="signup-input signup-input-password"
                  placeholder="Password (min 8 characters)"
                  required
                  minLength={8}
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="signup-password-toggle"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? (
                    <span className="signup-password-eye">🙈</span>
                  ) : (
                    <span className="signup-password-eye">👁️</span>
                  )}
                </button>
              </div>
            </label>
            <label className="signup-label">
              <div className="signup-password-wrap">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="signup-input signup-input-password"
                  placeholder="Confirm password"
                  required
                  minLength={8}
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="signup-password-toggle"
                  onClick={() => setShowConfirmPassword((v) => !v)}
                  aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
                >
                  {showConfirmPassword ? (
                    <span className="signup-password-eye">🙈</span>
                  ) : (
                    <span className="signup-password-eye">👁️</span>
                  )}
                </button>
              </div>
            </label>
            <label className="signup-checkbox-wrap">
              <input
                type="checkbox"
                checked={newsletter}
                onChange={(e) => setNewsletter(e.target.checked)}
                className="signup-checkbox"
              />
              <span className="signup-checkbox-label">Send me special offers, personalized recommendations, and learning tips.</span>
            </label>
            <button type="submit" className="signup-btn signup-btn-submit" disabled={loading}>
              {loading ? (
                <span className="btn-spinner" aria-label="Creating account" />
              ) : (
                'Continue'
              )}
            </button>
          </form>
          <p className="signup-terms">
            By signing up, you agree to our <Link to="/legal/terms" className="signup-terms-link">Terms of Use</Link> and <Link to="/legal/privacy" className="signup-terms-link">Privacy Policy</Link>.
          </p>
          <p className="signup-login-prompt">
            Already have an account? <Link to="/login" className="signup-login-link">Log in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
